import type { ApiFlowsExecutionsResponseType } from "@/types/entities/flows";
import { formatDateTime } from "@/utils/dates";
import type { Conditions } from "@/workflow_api/types/workflow";
import { Operations } from "@/workflow/components/configurations/if/operations";
import { getExecutionBadge } from ".";

interface Props {
  execution: ApiFlowsExecutionsResponseType["data"][number]["node_executions"][number];
}

const SwitchSimpleContent = ({ execution }: Props) => {
  const result = execution.outputs[0]?.value as string;

  const matchedCondition = execution.inputs.find(({ name }) => {
    return name === result;
  });

  const connection = execution.node.target_connections?.find((conn) => {
    return conn.ref_name === result;
  });

  console.log(connection?.display_name);

  return (
    <div className="border border-neutral rounded-lg p-4 bg-neutral-object flex flex-col gap-1">
      <p>Estado del nodo: {getExecutionBadge(execution.status)}</p>
      <p>Se completó el: {formatDateTime(execution.ended_at || "")}</p>
      {result !== "default" && (
        <OperationsFormatter conditions={matchedCondition?.conditions || []} />
      )}
      {result === "default" ? (
        <p>Se tomó la ruta por defecto, no cumplió con ninguna condición</p>
      ) : (
        <p>
          La condición que se cumplió fue:{" "}
          <span className="font-semibold">
            {connection?.display_name || ""}
          </span>
        </p>
      )}
    </div>
  );
};

const OperationsFormatter = ({ conditions }: { conditions: Conditions }) => {
  const firstCondition = conditions[0];

  const getOperation = (condition: Conditions[number]) => {
    const operationType = condition.input?.type?.toLowerCase() || "";
    const operations = Operations[operationType];
    if (!operations) return null;

    const operation = operations.find((op) => {
      return op.name === firstCondition.type;
    });
    if (!operation) return null;
    return operation;
  };

  return (
    <div>
      <p>
        La primera operación realizada que devolvió{" "}
        <span className="font-geist-mono bg-neutral-object-accent-loud p-1 rounded-lg">
          Verdadero
        </span>{" "}
        fue:{" "}
      </p>
      <p className="pl-4">
        <span>{JSON.stringify(firstCondition.input?.value as string)}</span>{" "}
        {getOperation(firstCondition)?.label || firstCondition.type}{" "}
        {firstCondition?.optional_input && (
          <span>
            {JSON.stringify(firstCondition?.optional_input.value as string)}
          </span>
        )}{" "}
        {/* {conditions.length > 1 && <span> {logicalOperator} </span>} */}
      </p>
      {/* {conditions.slice(1).map((condition, index) => {
        const operation = getOperation(condition);
        return (
          <p className="pl-4" key={index}>
            <span>{JSON.stringify(condition.input?.value as string)}</span>{" "}
            {operation?.label || condition.type}{" "}
            {condition?.optional_input && (
              <span>
                {JSON.stringify(condition?.optional_input.value as string)}
              </span>
            )}{" "}
            {index < conditions.length - 2 && <span> {logicalOperator} </span>}
          </p>
        );
      })} */}
    </div>
  );
};

export default SwitchSimpleContent;
